/**
 * Port of `repos/opencode/packages/session-ui/src/v2/components/session-progress-indicator-v2.tsx`,
 * keyed on the vendored stylesheet of the same name.
 *
 * A 5×5 dot grid. The component is 30 lines and the stylesheet 875, because every dot has
 * its own keyframes: the animation is entirely CSS, driven by the `data-dot` index. That
 * is also why the indices must be emitted even though nothing here reads them.
 */

import type { SVGAttributes } from "react";

const GRID = 5;
const DOT = 2;
const GAP = 1;
const ORIGIN = 1.5;

const dots = Array.from({ length: GRID * GRID }, (_, index) => ({
  index,
  x: ORIGIN + (index % GRID) * (DOT + GAP),
  y: ORIGIN + Math.floor(index / GRID) * (DOT + GAP)
}));

export function SessionProgressIndicator({
  width = 16,
  height = 16,
  ...rest
}: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-component="session-progress-indicator-v2"
      aria-hidden={rest["aria-hidden"] ?? "true"}
    >
      {dots.map((cell) => (
        <rect
          key={cell.index}
          data-dot={cell.index}
          x={cell.x}
          y={cell.y}
          width={DOT}
          height={DOT}
        />
      ))}
    </svg>
  );
}
